import React from 'react';
import { useTranslation } from 'react-i18next';

export interface LoginInfoSectionProps {
  email: string;
  onChangePassword: () => void;
}

/**
 * 로그인정보 section — MatchGo "Bright" styling.
 * Changes here are "즉시 반영" (applied immediately), unlike the save-button
 * sections, so it carries that tag in the header.
 */
const LoginInfoSection: React.FC<LoginInfoSectionProps> = ({
  email,
  onChangePassword,
}) => {
  const { t } = useTranslation('profile');

  return (
    <section className="px-6 sm:px-8 py-7 border-t border-[#EEF1F6]">
      <div className="flex items-center justify-between gap-2 pb-3.5 mb-2 border-b-2 border-[#0F1E3D]">
        <h2 className="text-[18px] font-bold tracking-tight text-[#0F1E3D]">
          {t('myProfile.form.loginInfo')}
        </h2>
        <span className="font-mono text-[10px] font-semibold text-[#6B7794] bg-[#F7F8FB] border border-[#E4E8F0] rounded px-2 py-0.5">
          {t('myProfile.form.instantTag', '즉시 반영')}
        </span>
      </div>

      {/* Password */}
      <div className="grid sm:grid-cols-[120px_1fr] gap-2 sm:gap-4 py-4 border-b border-[#EEF1F6]">
        <div className="text-[13px] font-bold text-[#0F1E3D] sm:pt-2">
          {t('myProfile.form.password', '비밀번호')}
        </div>
        <div>
          <button
            type="button"
            onClick={onChangePassword}
            className="inline-flex items-center justify-center px-4 py-2.5 text-[13.5px] font-bold rounded-lg border-[1.5px] border-[#0F1E3D] text-[#0F1E3D] bg-white hover:bg-[#0F1E3D] hover:text-white transition"
          >
            {t('myProfile.form.changePassword')}
          </button>
        </div>
      </div>

      {/* Email (read-only) */}
      <div className="grid sm:grid-cols-[120px_1fr] gap-2 sm:gap-4 py-4">
        <div className="text-[13px] font-bold text-[#0F1E3D] sm:pt-2.5">
          {t('myProfile.form.email')}
        </div>
        <div>
          <input
            id="email"
            type="email"
            value={email}
            readOnly
            className="w-full max-w-[320px] px-3.5 py-2.5 text-sm rounded-lg border-[1.5px] border-[#E4E8F0] bg-[#F7F8FB] text-[#6B7794] cursor-not-allowed focus:outline-none"
          />
          <p className="mt-2 text-xs text-[#6B7794] leading-relaxed">
            {t('myProfile.form.emailHelp', '가입 시 입력한 값 또는 SNS 연동으로 추출된 메일 주소가 표기됩니다.')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default LoginInfoSection;
